import { useEffect, useState } from "react";
import { TimelineView } from "../../../../../components/widgets/TimelineWidget/Timeline_view";
import I18n from "../../../../../core/localization/I18n";
import { TrainingTimelineReportModel } from "./TrainingTimelineReportView_model";
import { useCurrentOrganisationId } from "../../../../../services/local/organisationContext/OrganisationContextModel";
import { useParams } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { ReportingCard, ReportingTitle } from "../../view/components/ReportingPie";
import "./_training-timeline-report-view.scss";

export const TrainingTimelineReportView: React.FC = observer(() => {
  let organisationId = useCurrentOrganisationId();
  let { projectId } = useParams<{ projectId: string }>();
  const [model] = useState(() => new TrainingTimelineReportModel(organisationId, +projectId));

  useEffect(() => {
    model.onMount();
    //eslint-disable-next-line
  }, []);

  return (
    <div className="container-fluid org-timeline action-timeline">
      <div className="row mt-5" style={{ marginBottom: "90px" }}>
        <div className="col module-timeline">
          {!model.isLoading && (
            <ReportingCard className="p-3 pb-8">
              <ReportingTitle title={I18n.t("phrases.timelineReport")} className="pb-3" />
              <TimelineView
                model={model.timelineModel}
                timelineProps={{ lineHeight: 40 } as any}
                labels={{
                  noItemsText: I18n.t("phrases.noCourses"),
                  today: I18n.t("phrases.today"),
                  scrollLeft: I18n.t("phrases.scrollLeft"),
                  scrollRight: I18n.t("phrases.scrollRight"),
                  zoomOut: I18n.t("phrases.zoomOut"),
                  zoomIn: I18n.t("phrases.zoomIn"),
                  resetZoom: I18n.t("phrases.resetZoom")
                }}
              />
            </ReportingCard>
          )}
        </div>
      </div>
    </div>
  );
});
